import React, { useEffect, useState } from "react";

import { classnames, Icon, PlainButton } from "@culturehq/components";

import facebook from "images/social/facebook.svg";
import linkedin from "images/social/linkedin.svg";
import twitter from "images/social/twitter.svg";
import instagram from "images/social/instagram.svg";
import tiktok from "images/social/tiktok.svg";
import tagsTypes from "constants/tagsTypes";

const SocialMediaTab = ({
  activeSocialMediaText,
  onChangeActiveText,
  socialMediaSelected
}) => {
  const [color, setColor] = useState("#0077B7");
  const [active, setActive] = useState(activeSocialMediaText === socialMediaSelected);

  useEffect(
    () => {
      setActive(activeSocialMediaText === socialMediaSelected);

      const getColor = () => {
        switch (socialMediaSelected) {
          case "Facebook":
            return "#4267B2";
          case "Instagram":
            return "#FD1D1D";
          case "LinkedIn":
            return "#0077B7";
          case "TikTok":
            return "#000000";
          case "Twitter":
            return "#00ACEE";
          default:
            return "#0077B7";
        }
      };

      if (activeSocialMediaText === socialMediaSelected) {
        setColor(getColor(socialMediaSelected));
      } else {
        setColor("#888");
      }
    },
    [activeSocialMediaText, socialMediaSelected]
  );

  return (
    <li role="navigation">
      <PlainButton
        className={classnames(socialMediaSelected, { active })}
        onClick={() => { onChangeActiveText(socialMediaSelected); }}
        style={{ borderColor: color, color }}
      >
        {active ? (
          <img className="social-icon image" src={getSocialIcon(socialMediaSelected)} alt={socialMediaSelected} />
        ) : (
          <Icon className="social-icon" icon={getIcon(socialMediaSelected)} />
        )}
        {socialMediaSelected}
      </PlainButton>
    </li>
  );
};

const getIcon = socialMedia => {
  switch (socialMedia) {
    case "Instagram":
      return "instagram";
    case "Facebook":
      return "facebook";
    case "LinkedIn":
      return "linkedin";
    case "Twitter":
      return "twitter";
    case "TikTok":
      return "tiktok";
    default:
      return "";
  }
};

const getSocialIcon = socialMedia => {
  switch (socialMedia) {
    case "Instagram":
      return instagram;
    case "Facebook":
      return facebook;
    case "LinkedIn":
      return linkedin;
    case "Twitter":
      return twitter;
    case "TikTok":
      return tiktok;
    default:
      return "";
  }
};

const getEntityParams = values => {
  const params = {
    companyIds: [],
    departmentIds: [],
    interestIds: [],
    locationIds: [],
    organizationIds: [],
    skillIds: [],
    userIds: [],
    classYearIds: [],
    clubIds: [],
    programIds: [],
    degreeIds: []
  };

  values.forEach(value => {
    switch (value.category) {
      case "companies":
        params.companyIds.push(value.value);
        break;
      case "departments":
        params.departmentIds.push(value.value);
        break;
      case "interests":
        params.interestIds.push(value.value);
        break;
      case "locations":
        params.locationIds.push(value.value);
        break;
      case "skills":
        params.skillIds.push(value.value);
        break;
      case "classYears":
      case "class years":
        params.classYearIds.push(value.value);
        break;
      case "clubs":
        params.clubIds.push(value.value);
        break;
      case "programs":
        params.programIds.push(value.value);
        break;
      case "degrees":
        params.degreeIds.push(value.value);
        break;
      case tagsTypes.ALL_ORGANIZATION:
        params.organizationIds.push(value.value);
        break;
      default:
        params.userIds.push(value.value);
        break;
    }
  });

  return params;
};

export default SocialMediaTab;
